import React from "react";

export const GalleryIndicators = ({
  onClickHandler,
  isSelected,
  index,
  label,
}) => {
  if (isSelected) {
    return (
      <li
        className="dot selected"
        aria-label={`Selected: ${label} ${index + 1}`}
        title={`Selected: ${label} ${index + 1}`}
      >
        <span>(</span>
        {index + 1}
        <span>)</span>
      </li>
    );
  }
  return (
    <li
      className="dot"
      onClick={onClickHandler}
      onKeyDown={onClickHandler}
      value={index}
      key={index}
      role="button"
      tabIndex={0}
      title={`${label} ${index + 1}`}
      aria-label={`${label} ${index + 1}`}
    >
      <span>(</span>
      {index + 1}
      <span>)</span>
    </li>
  );
};
